
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/magnite",
      function () {
        return require("private-next-pages/destinations/magnite.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/magnite"])
      });
    }
  